<template>
  <p class="maxlength-error-wuk text-right t4" v-if="passedMaxChars">
    <span>{{ overflow }}</span>
  </p>
</template>

<script>
export default {
  name: 'MaxlengthErrorWuk',
  props: {
    validation: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    overflow() {
      if (!this.value) {
        return 0;
      }

      return this.validation.$params.maxLength.max - this.value.length;
    },
    passedMaxChars() {
      if (!('maxLength' in this.validation) || !this.value) {
        return false;
      }

      return this.value.length > this.validation.$params.maxLength.max;
    },
  },
};
</script>
